const ENTIDADES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

/** Para meter un dato en HTML: que se lea como texto, nunca como etiqueta. */
export const escaparHtml = (valor) =>
  String(valor ?? '').replace(/[&<>"']/g, (caracter) => ENTIDADES[caracter]);
